<template>

<app-page />

</template>

<script>

export default {

	created: function() {

		this.$api.request('logout').then(function() {

			this.$router.push({
				name: 'Home'
			})

		}.bind(this))

	}

}

</script>